
























import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SheetEditor',
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: 'sheet',
    });
    return {
      buffer,
      save,
    };
  },
});
